module.exports = __webpack_public_path__ + "static/img/logo.6de5fe8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/logo.jpg
// module id = kDbk
// module chunks = 202